import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { useIsJobsEnabled } from "../../PlacementCandidate/useIsJobsEnabled";
import { PLACEMENT_PATHS } from "../../Placements/paths";

export function EducationalJobsButton() {
  const isJobsEnabled = useIsJobsEnabled();
  const history = useHistory();

  if (!isJobsEnabled) {
    return null;
  }

  return (
    <>
      <Text sx={{ textAlign: "center", paddingX: 7, textWrap: "balance" }} variant="body2">
        These documents are NOT required to apply and interview for permanent positions at
        workplaces
      </Text>
      <Button
        variant="contained"
        size="small"
        onClick={() => {
          history.push(PLACEMENT_PATHS.ROOT);
        }}
      >
        Browse Open Jobs
      </Button>
    </>
  );
}
